/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HeadphonesDenyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACXUlEQVR4nNVVSWsUURDuHFwQV1SCYMSj0Z/gQb1Ix7xaJvBS1Q4yIjpXY/Tmgij4C/IvPOQioojowZtgvEhwJww5eDBxFCUXjbzX3TNvlm4nLgcLhul5/dVX9aq+qomiPzRDCQPJHWBZBpIPSPIYUXEgZ0TcAix1YLmNrAuehOVe6z3JLWRd7fcBkpuFxNba9chyGVg/9zrqlMMQJZCdrSDLtDHJLjORHECWZo41LGM95JVKdS+wzLUIWR8QJWeZZdRauznI/mGKkWn3G0CHgfVFdpYGIb3fQU4kI0DSSF/KPOLkscLyZSTMp3aG5O4bQA+lz7LccjhSq20ElmdZ5Cfj4yd3lPUHSD95LNqDXeTDsbW7s5ssBRnplaws76y128rInbnSheXIyf070osdJYrj6lYg/eKBE5OHowGMKDnRbr40XY8qleqejHzFc1U09mBkPZNl8ShagyHrjYFkmuncHZ6O1miGZSwtlyuVNN1zjzyB9E2qCBmN/oVBNlDGmE1/hY90Kpx4V8uvLkA4SL9r1m8BP/Hf2gFIXnU2SZaQ9G7ZoOVGJEcdFkg/djSZ9X1wA5ktUMOPfBX0M0S9kGL6+cpsECCVaVEQyPUcmGE5DiTfS/zOBdesbW+Nfj9Nsyy6nZPj/f5hWSwml6bj7MgISK6WZLMKJDMBduYX2Os99YzjeAOwPC1xXAgCNEpuO+e4ihSx33W/rzPJfDuAvizIvOFWfpEo8iAj4R8Otut6vks9XQnoc2PsvmgQq9fr6/z6JnnrMjckl6IoGgogQ06+yPraY1iuFZblv7ef7LTuzcqeWqUAAAAASUVORK5CYII=)
 */
export const HeadphonesDenyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M21.76.83a5.02 5.02 0 0 1 .78 7.7 5 5 0 0 1-7.07 0 5.02 5.02 0 0 1 0-7.07 5 5 0 0 1 6.29-.63Zm-4.88 2.05a3 3 0 0 1 3.41-.59l-4 4a3 3 0 0 1 .59-3.41Zm4.83.83-4 4a3 3 0 0 0 4-4Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.38 1c.38.02.58.45.4.78-.15.3-.3.62-.4.95A.4.4 0 0 1 12 3a9 9 0 0 0-8.95 10h1.87a5 5 0 0 1 4.1 2.13l1.37 1.97a3.1 3.1 0 0 1-.17 3.78 2.85 2.85 0 0 1-3.55.74 11 11 0 0 1 5.71-20.61ZM22.22 11.22c.34-.18.76.02.77.4L23 12a11 11 0 0 1-5.67 9.62c-1.27.71-2.73.23-3.55-.74a3.1 3.1 0 0 1-.17-3.78l1.38-1.97a5 5 0 0 1 4.1-2.13h1.86c.03-.33.05-.66.05-1a.4.4 0 0 1 .27-.38c.33-.1.65-.25.95-.4Z"
        className={colorClass}
      />
    </svg>
  );
};
